"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpenseSchemaVersion = void 0;
var ExpenseSchemaVersion;
(function (ExpenseSchemaVersion) {
    /**
     * Initial version
     */
    ExpenseSchemaVersion[ExpenseSchemaVersion["V1"] = 1] = "V1";
    /**
     * Added GOB field level validations
     */
    ExpenseSchemaVersion[ExpenseSchemaVersion["V2"] = 2] = "V2";
})(ExpenseSchemaVersion || (exports.ExpenseSchemaVersion = ExpenseSchemaVersion = {}));
